module.exports = __webpack_public_path__ + "static/img/cont3617.88d9170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3617.jpg
// module id = HguY
// module chunks = 0